import { render, staticRenderFns } from "./ProgramSurveys.vue?vue&type=template&id=39328c09"
import script from "./ProgramSurveys.vue?vue&type=script&lang=js"
export * from "./ProgramSurveys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports